/**
 * Copyright (c) Granthika Co., All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 */

export default class User {

  constructor(readonly token : string, 
              readonly name : string, 
              readonly email : string,
              readonly hghandle: string) {
  }
}